import { Button, Dialog, Flex, Alert } from '@/_components';
import { UnattachedPreviewDialogProps } from './UnattachedPreviewDialog.types';
import { UnattachedPreviewTab } from '../UnattachedPreviewTab';

export const UnattachedPreviewDialog = ({
  isOpen,
  onClose,
  onExportToggle,
  initialDocuments,
  questionnaire,
  reloadQuestionnairePreview,
}: UnattachedPreviewDialogProps) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Unattached Documents">
      <Dialog.Content>
        <Flex isColumn={true} gap={10}>
          <Alert type="info">
            Only showing recent documents (Uploaded within the last 3 months).
          </Alert>
          <UnattachedPreviewTab
            hideDefaultAlert={true}
            initialDocuments={initialDocuments}
            from3MonthsAgo={true}
            questionnaire={questionnaire}
            reloadQuestionnairePreview={reloadQuestionnairePreview}
          />
          <Button
            intent="primary"
            size="small"
            iconRight="download"
            onClick={onExportToggle}
            value="Go to export"
          />
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
